module.exports = __webpack_public_path__ + "img/favicon.83b1a5ce.png";